export default __webpack_public_path__ + "static/experienceBg-df1010718cf95b4ce24da8950eb327ee.png";